import { TopMarketRequestsType } from '../../constants';
import { useMapTopMarketRequestsData } from '../../hooks/useMapTopMarketRequestsData';

import { TopMarketRequestsTable } from './components/TopMarketRequestsTable';

export const TopMarketRequests = () => {
  const {
    tableData: { top_bundles, top_domains },
  } = useMapTopMarketRequestsData();

  return (
    <>
      <TopMarketRequestsTable type={TopMarketRequestsType.DOMAINS} tableData={top_domains} />
      <TopMarketRequestsTable type={TopMarketRequestsType.BUNDLES} tableData={top_bundles} />
    </>
  );
};
